import { render } from "./ProfilePassword.vue?vue&type=template&id=d5347946&scoped=true"
import script from "./ProfilePassword.vue?vue&type=script&lang=js"
export * from "./ProfilePassword.vue?vue&type=script&lang=js"

import "./ProfilePassword.vue?vue&type=style&index=0&id=d5347946&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5347946"]])

export default __exports__